import React from 'react';
import Card from '../components/card';
import Checkbox from '../components/Checkbox';
import { LoanCard } from './card-lenses';

const Product = ({ model, label, property, onChange }) => (
  <Checkbox
    style={{ marginTop: '0.5em' }}
    label={label}
    value={model.get(property)}
    onChange={onChange.bind(null, property)}
  />
);

const LoanType = ({ model, onChange, ...cardProps }) => (
  <Card title="Which product type(s) are you considering for your new loan?" {...cardProps}>
    <Product label="30 Year Fixed" property="fixed30" model={model} onChange={onChange} />
    <Product label="20 Year Fixed" property="fixed20" model={model} onChange={onChange} />
    <Product label="15 Year Fixed" property="fixed15" model={model} onChange={onChange} />
    <Product label="10 Year Fixed" property="fixed10" model={model} onChange={onChange} />
    <Product label="5/1 ARM" property="arm5" model={model} onChange={onChange} />
    <Product label="7/1 ARM" property="arm7" model={model} onChange={onChange} />
    <Product label="10/1 ARM" property="arm10" model={model} onChange={onChange} />
  </Card>
);

LoanType.completed = ({ model }) =>
  model.get('fixed30') ||
  model.get('fixed20') ||
  model.get('fixed15') ||
  model.get('fixed10') ||
  model.get('arm5') ||
  model.get('arm7') ||
  model.get('arm10');

LoanType.id = 'LoanType';

export default LoanCard(LoanType);



// WEBPACK FOOTER //
// ./src/cards/loan-type.js